import { Component, input } from '@angular/core';
import { WarningComponent } from '../../domains/data-capturing/warnings/warning.component';
import { Proof301DataOverview } from '../../service/api/personenschaden-api.service';

@Component({
  selector: 'ct-extraction-existing-301-warning',
  templateUrl: 'existing-301-warning.component.html',
  imports: [WarningComponent],
})
export class Existing301WarningComponent {
  readonly proof301Overview = input.required<Proof301DataOverview>();
}
